module.exports = __webpack_public_path__ + "img/aftersell-submit-tips-en.bbbe49ed.png";